import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import { ROUTE_RECIPIENTS } from './recipients'
import { ROUTE_NOT_AUTHENTICATED } from './notAuthenticated'
import { ROUTE_USERS } from './users'
import { ROUTE_COMPANIES } from './companies'
import { ROUTE_FINANCIAL } from './financial'
import { ROUTE_CONFIG } from './config'
import { RequireAutorization } from './routerAuth'

const Dashboard = () => import(/* webpackChunkName: "main" */ '@/components/Dashboard.vue')
const NotFound = () => import(/* webpackChunkName: "main" */ '@/views/NotFound.vue')
const ServiceFiles = () => import(/* webpackChunkName: "serviceFiles" */ '@/components/serviceFiles/Index.vue')

Vue.use(VueRouter)

const routes = [
  // Authenticated routes
  {
    path: '/',
    component: Dashboard,
    meta: { title: '' },
    children: [
      {
        path: '/',
        name: 'Dashboard',
        component: Home,
        beforeEnter: RequireAutorization
      },
      {
        path: '/arquivos_servico',
        name: 'ServiceFiles',
        component: ServiceFiles,
        beforeEnter: RequireAutorization
      },
      ...ROUTE_RECIPIENTS,
      ...ROUTE_USERS,
      ...ROUTE_COMPANIES,
      ...ROUTE_FINANCIAL,
      ...ROUTE_CONFIG
    ]
  },
  ...ROUTE_NOT_AUTHENTICATED,
  {
    name: 'NotFound',
    path: '*',
    component: NotFound
  }
]

const router = new VueRouter({ routes, mode: 'history' })

export default router
